import styled from 'styled-components'

import { ClosingX } from '../shared/ClosingX'
import { IconButton } from '../shared/styledComponents'

const Container = styled.div`
  width: 100%;
  max-width: 780px; /* IE */
  margin: 2px 0;
`

const BannerCard = styled.div<{ backgroundColor: string; borderColor: string }>`
  display: flex;
  flex-direction: row;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: ${props => props.backgroundColor};
  border-left: ${props => '.5rem solid ' + props.borderColor};
  min-height: auto;
`

const Flag = styled.i`
  position: relative;
  margin: auto 0px auto 24px;
  display: block;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    margin: 30px 0px auto 24px; /* IE */
 }
`
const TextContainer = styled.div<{ textColor: string }>`
  font-style: normal;
  font-stretch: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 54px 0 38px;
  padding: 24px 0;
  color: ${props => props.textColor};
`
const Title = styled.div`
  font-weight: 600;
  font-family: FreightSans, sans-serif;
  letter-spacing: 1px;
`

const Message = styled.span`
  font-family: NeueHaasUnica, sans-serif;
  letter-spacing: 0.1px;
`

const ModalClose = styled(IconButton)`
  margin: 10px 10px 0 auto;
  display: inline-block;
  width: 10px;
  height: 10px;
`

type BannerProps = {
  backgroundColor: string
  textColor: string
  borderColor: string
  flag: React.ReactNode
  children: string
  handleClose?(): void
  title: string
}

const Banner = ({
  backgroundColor,
  textColor,
  borderColor,
  flag,
  children,
  handleClose,
  title
}: BannerProps) => (
  <Container>
    <BannerCard role='alert' backgroundColor={backgroundColor} borderColor={borderColor} >
      <Flag>{flag}</Flag>
      <TextContainer role='note' textColor={textColor}>
        <Title>{title}</Title>
        <Message id="validationMessage" dangerouslySetInnerHTML={{ __html: children }} />
      </TextContainer>
      {handleClose &&
          <ModalClose
            className="modal-close"
            type="button"
            onClick={handleClose}
          >
            <ClosingX width='10px' height='10px' fill={borderColor}/>
          </ModalClose>
      }
    </BannerCard>
  </Container>
)

export { Banner }
